import { flatten, keys } from "lodash";
import { createSelector, Selector } from "reselect";
import { QuestionMap } from "@teamprevent/common/model";

import { QuestionnairesState } from "../model";

import { CustomQuestionConfig, MasterQuestionConfig, QuestionnaireConfig, AdditionalQuestionsSectionId } from "./models";

const mapQuestionMapToArray = (questionMap: QuestionMap) => {
    return keys(questionMap).map<CustomQuestionConfig>(id => ({ id, questionText: questionMap[id].question }));
};

export function selectQuestionnaireAsQuestionnaireConfigFactory(
    questionnaireKey: string
) {
    const questionnaireSelector = (state: { questionnaires: QuestionnairesState }) => state.questionnaires[questionnaireKey];
    return createSelector(
        questionnaireSelector,
        (questionnaire) => {
            const sections = (questionnaire || { sections: [] }).sections;
            const additionalSection = sections.find(s => s.id === AdditionalQuestionsSectionId);
            return {
                questions: flatten(sections.map(s => mapQuestionMapToArray(s.questions))),
                additionalQuestions: additionalSection && mapQuestionMapToArray(additionalSection.questions)
            };
        }
    );
}

export function selectAndMergeCustomQuestionnaireConfigFactory<T>(
    masterConfig: MasterQuestionConfig[],
    customConfigSelector: Selector<T, QuestionnaireConfig>
) {
    return createSelector(customConfigSelector, (customConfig) => {
        if (customConfig && customConfig.questions === undefined) {
            return {
                questions: masterConfig,
                additionalQuestions: []
            };
        } else if (customConfig && customConfig.questions) {
            return {
                questions: masterConfig.map(m => customConfig.questions.find(c => c.id === m.id) || m),
                additionalQuestions: customConfig.additionalQuestions
            };
        }

        return null;
    });
}

export function selectAndMergePhysiotherapyMgrReferralQuestionnaireConfigFactory<T>(
    masterConfig: MasterQuestionConfig[],
    customConfigSelector: Selector<T, QuestionnaireConfig>
) {
    return createSelector(customConfigSelector, (customConfig) => {
        if (customConfig && customConfig.questions === undefined) {
            return {
                questions: masterConfig,
                additionalQuestions: []
            };
        } else if (customConfig && customConfig.questions) {
            return {
                questions: masterConfig.map(m => customConfig.questions.find(c => c.id === m.id) || m),
                additionalQuestions: customConfig.additionalQuestions
            };
        }

        return null;
    });
}

export function selectAndMergePhysiotherapySelfReferralQuestionnaireConfigFactory<T>(
    masterConfig: MasterQuestionConfig[],
    customConfigSelector: Selector<T, QuestionnaireConfig>
) {
    return createSelector(customConfigSelector, (customConfig) => {
        if (customConfig && customConfig.questions === undefined) {
            return {
                questions: masterConfig,
                additionalQuestions: []
            };
        } else if (customConfig && customConfig.questions) {
            return {
                questions: masterConfig.map(m => customConfig.questions.find(c => c.id === m.id) || m),
                additionalQuestions: customConfig.additionalQuestions
            };
        }

        return null;
    });
}
